import axiosClient from './axiosClient'
const organizationallevelApi = {
  getAll: (params) => {
    const url = '/organizationallevel/getAll'
    return axiosClient.get(url, { params })
  },
}
export default organizationallevelApi
